// BUG-11 fix: أداة مشتركة للتحقق من لغة الحقول (منع خلط العربي بالإنجليزي)
// تُستخدم في أي فورم إضافة/تعديل يحتوي حقول title_ar / title_en / name_ar / name_en ... إلخ

// نطاق الحروف العربية (يشمل الأرقام العربية والعلامات الشائعة)
const ARABIC_LETTER = /[؀-ۿ]/;
// الحروف اللاتينية (الإنجليزية)
const LATIN_LETTER = /[A-Za-z]/;

/**
 * يتحقق أن النص لا يحتوي على حروف لاتينية (أي حقل عربي).
 * يسمح بالأرقام والمسافات وعلامات الترقيم.
 */
export const isArabicField = (value) => {
  if (!value) return true; // الحقل الفارغ يُترك لقاعدة required
  return !LATIN_LETTER.test(value);
};

/**
 * يتحقق أن النص لا يحتوي على حروف عربية (أي حقل إنجليزي).
 */
export const isEnglishField = (value) => {
  if (!value) return true;
  return !ARABIC_LETTER.test(value);
};

/**
 * دالة تحقق شاملة: تُرجع رسالة الخطأ أو null إذا كان الحقل سليماً.
 * @param {string} value قيمة الحقل
 * @param {"ar"|"en"} lang اللغة المتوقعة للحقل
 */
export const validateFieldLanguage = (value, lang) => {
  if (lang === "ar" && !isArabicField(value)) {
    return "هذا الحقل مخصص للغة العربية فقط (لا يسمح بحروف إنجليزية)";
  }
  if (lang === "en" && !isEnglishField(value)) {
    return "This field accepts English letters only (Arabic is not allowed)";
  }
  return null;
};
